/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {ProjectDefaultsResponse} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Returns the default project (one scene) used to bootstrap a new project.
 */
export type getProjectDefaultsResponse200 = {
  data: ProjectDefaultsResponse
  status: 200
}

export type getProjectDefaultsResponseSuccess = getProjectDefaultsResponse200 & {
  headers: Headers
}
export type getProjectDefaultsResponse = getProjectDefaultsResponseSuccess

export const getGetProjectDefaultsUrl = () => {
  return `/defaults/project`
}

export const getProjectDefaults = async (options?: RequestInit): Promise<getProjectDefaultsResponse> => {
  return customFetch<getProjectDefaultsResponse>(getGetProjectDefaultsUrl(), {
    ...options,
    method: 'GET',
  })
}
